'use client';

import { mediaSection } from '@stereoagency/sanity-schema';
import { MediaSection as UIMediaSection } from '@stereoagency/ui';
import { sanityImageAsProps } from '@/utils';
import { SimpleBlockContent } from '../sanity/client';

type Props = typeof mediaSection.schema.mediaSection;

export default function MediaSection({
  variant,
  image,
  label,
  caption,
  video
}: Props) {
  if (!image?.asset._ref) {
    return null;
  }

  return (
    <UIMediaSection
      variant={variant}
      image={sanityImageAsProps(image)}
      label={caption ? <SimpleBlockContent value={caption} /> : label}
      video={video}
    />
  );
}
